import { useAuth } from './useAuth';

/**
 * Hook per gestire i permessi utente
 */
export function usePermissions() {
  const { user } = useAuth();

  // 🔥 DEBUG: Log user data
  console.log('🔐 usePermissions - user:', user);
  console.log('🔐 usePermissions - permissions:', user?.permissions);
  console.log('🔐 usePermissions - role:', user?.role);

  /**
   * Verifica se l'utente ha un permesso specifico
   * @param {string} permission - Nome del permesso da verificare
   * @returns {boolean} - true se l'utente ha il permesso
   */
  const hasPermission = (permission) => {
    if (!user || !user.permissions) {
      console.warn(`⚠️ hasPermission('${permission}'): user o permissions non disponibili`);
      return false;
    }
    const result = user.permissions.includes(permission);
    console.log(`🔐 hasPermission('${permission}'): ${result}`);
    return result;
  };

  /**
   * Verifica se l'utente ha almeno uno dei permessi specificati
   * @param {string[]} permissions - Array di permessi
   * @returns {boolean} - true se l'utente ha almeno un permesso
   */
  const hasAnyPermission = (permissions) => {
    if (!user || !user.permissions) {
      return false;
    }
    return permissions.some(permission => user.permissions.includes(permission));
  };

  /**
   * Verifica se l'utente ha tutti i permessi specificati
   * @param {string[]} permissions - Array di permessi
   * @returns {boolean} - true se l'utente ha tutti i permessi
   */
  const hasAllPermissions = (permissions) => {
    if (!user || !user.permissions) {
      return false;
    }
    return permissions.every(permission => user.permissions.includes(permission));
  };

  /**
   * Verifica se l'utente ha un ruolo specifico
   * @param {string} role - Nome del ruolo
   * @returns {boolean} - true se l'utente ha il ruolo
   */
  const hasRole = (role) => {
    if (!user || !user.role) {
      return false;
    }
    return user.role === role;
  };

  /**
   * Verifica se l'utente ha almeno uno dei ruoli specificati
   * @param {string[]} roles - Array di ruoli
   * @returns {boolean} - true se l'utente ha almeno un ruolo
   */
  const hasAnyRole = (roles) => {
    if (!user || !user.role) {
      return false;
    }
    return roles.includes(user.role);
  };

  /**
   * Verifica se l'utente è admin
   * @returns {boolean} - true se l'utente è admin
   */
  const isAdmin = () => {
    return hasRole('admin');
  };

  /**
   * Verifica se l'utente è associato
   * @returns {boolean} - true se l'utente è associato
   */
  const isAssociato = () => {
    return hasRole('associati');
  };

  /**
   * Verifica se l'utente è guest
   * @returns {boolean} - true se l'utente è guest
   */
  const isGuest = () => {
    return hasRole('guest');
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
    hasAnyRole,
    isAdmin,
    isAssociato,
    isGuest,
    permissions: user?.permissions || [],
    role: user?.role || null
  };
}

